import template from './periodCardIcon.html';
import controller from './periodCardIcon.controller';
import './periodCardIcon.scss';

let periodCardIconComponent = {
  restrict: 'E',
  bindings: {
    status: '<'
  },
  template,
  controller
};

export default periodCardIconComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodCard/periodCardIcon/periodCardIcon.component.js